export const fontImports = [
    {
        family: 'SofiaPro',
        folder: 'nutribullet',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Medium',
                weight: 500,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
    {
        family: 'NotoSans',
        folder: 'global',
        variants: [
            {
                name: 'Regular',
                weight: 400,
            },
            {
                name: 'Bold',
                weight: 700,
            },
        ],
    },
]
